import { AuthorizationResponse } from "./types";
import * as types from "./authorization.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { ParsedPermission } from "../../interfaces/UserRole";

export const updateError = (value: ErrorResponse) => action(types.SET_ERROR, { value });
export const updateMessage = (value: string) => action(types.SET_MESSAGE, { value });

export const getUserAsync = createAsyncAction(
  types.GET_USER_REQUEST,
  types.GET_USER_SUCCESS,
  types.GET_USER_FAILURE
)<{ authToken: string }, { response: AuthorizationResponse, systemAccess: ParsedPermission, token: string }, ErrorResponse>();